export default {
  methods: {
    getFileNameFromContentDisposition(contentDisposition) {
      const matches = contentDisposition.match(/filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/i);
      return Buffer.from( matches[3] !== undefined ? decodeURIComponent(matches[3]) : matches[2] !== undefined ? decodeURIComponent(matches[2]) : '', 'binary').toString('utf8');
    },
  },
};
